/**
 * Undo action utilities
 */

import toast from 'react-hot-toast';

/**
 * Create an undoable action
 * @param {Function} action - The action to perform
 * @param {Function} undoAction - The function to undo the action
 * @param {string} successMessage - Message to show on success
 * @param {number} undoTimeout - Time in milliseconds before undo expires (default: 5000)
 * @returns {Promise} Result of the action
 */
export const createUndoableAction = async (
  action,
  undoAction,
  successMessage = 'Action completed',
  undoTimeout = 5000
) => {
  // Perform the action
  const result = await action();
  
  // Show toast with undo button
  let undoTimer;
  const toastId = toast.success(
    (t) => (
      <div>
        <div style={{ marginBottom: '8px' }}>{successMessage}</div>
        <button
          onClick={() => {
            clearTimeout(undoTimer);
            toast.dismiss(t.id);
            undoAction();
            toast.success('Action undone');
          }}
          style={{
            background: 'transparent',
            border: '1px solid currentColor',
            color: 'inherit',
            padding: '4px 12px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '0.875rem',
          }}
        >
          Undo
        </button>
      </div>
    ),
    {
      duration: undoTimeout + 1000, // Slightly longer than undo timeout
    }
  );

  // Auto-dismiss undo after timeout
  undoTimer = setTimeout(() => {
    toast.dismiss(toastId);
  }, undoTimeout);

  return result;
};

